/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import SubscribeNewsletterPopUpContainer from "./SubscribeNewsletterPopUp.container";

export default SubscribeNewsletterPopUpContainer;
